<script>
  import { _ } from 'svelte-i18n'
  import { previews_nav_filters, detected_fonts, user, just_switched_to_local_fonts } from '../../stores'
  import UAParser from 'ua-parser-js'
  import Content_YourFonts_Extension from './your_fonts/Extension.svelte'
  import Content_YourFonts_LocalFonts from './your_fonts/LocalFonts.svelte'
  import Content_YourFonts_Mobile from './your_fonts/Mobile.svelte'
  import Content_YourFonts_NoSupport from './your_fonts/NoSupport.svelte'
  import TimesButton from '../../elements/TimesButton.svelte'
  
  export let insert_position

  const uaParser = new UAParser()
  const browser = uaParser.getBrowser()
  const device = uaParser.getDevice()

  const is_mobile_or_tablet = device.type === 'mobile' || device.type === 'tablet' 
  const supports_local_font_access = 'queryLocalFonts' in self
  const supports_chrome_extension = ('chrome' in self) ? ('runtime' in chrome) ? ('sendMessage' in chrome.runtime) ? true: false: false : false
  const has_extension = $detected_fonts && $detected_fonts.length > 0 && $detected_fonts[0]?.source === 'extension'

  let permission_denied = false
  let reload_required = false

  getPermissionStatus()
  
  async function getPermissionStatus() {
    if ('queryLocalFonts' in self) {
      const status = await navigator.permissions.query({ name: "local-fonts" })
      if (status.state === "denied") permission_denied = true
    }
  }

  const hide = () => { insert_position = "" }
</script>

{#if insert_position === 'before_previews'}
  {#if has_extension || $just_switched_to_local_fonts}
    <TimesButton on:click={hide}/>
  {/if}
  <div class="content">
    <h1>
      {#if reload_required}
        Thanks!
      {:else if $just_switched_to_local_fonts && has_extension}
        Awesome! This is much better!
      {:else if $just_switched_to_local_fonts}  
        Great!
      {:else if permission_denied || ($user !== undefined && !has_extension)}
        Permission to show your fonts?
      {:else if has_extension}
        A better way to detect your fonts 🎉
      {:else if $previews_nav_filters.user}
        This is where it gets better 👌
      {:else}
        Before you start ☝️
      {/if}
    </h1>
      
    {#if is_mobile_or_tablet}
      <Content_YourFonts_Mobile/>
    
    {:else if (supports_local_font_access)}
      <Content_YourFonts_LocalFonts 
        {browser} 
        {has_extension} 
        bind:permission_denied
        on:hide={() => hide()}/>

    {:else if (supports_chrome_extension)}
      <Content_YourFonts_Extension bind:reload_required/>

    {:else}
      <Content_YourFonts_NoSupport {browser} />
    {/if}

  </div>
{/if}

<style>
 .content {
    padding: 5rem 2rem 3rem 2rem;
    text-align: left;
    background-color: var(--c-bg);
  }

  .content h1 {
    margin-bottom: 2rem;
    font-family: var(--PensumDisplay);
    font-size: 5rem;
    line-height: 5.2rem;
    letter-spacing: 0.05rem;
    color: var(--c-text-big);
  }

  .content :global(h2) {
    margin-left: 0.2rem;
  }
</style>